import React from 'react';
import style from '../css/NewStudyMethod.module.css';

import { FaUsers, FaUserGraduate } from 'react-icons/fa';
import { IoDocumentText } from 'react-icons/io5';
import { BsCollectionPlayFill } from 'react-icons/bs';
import study1 from '../images/study1.png';

import img1 from '../images/study-method/1.svg';
import img2 from '../images/study-method/2.svg';
import img3 from '../images/study-method/3.svg';
import img4 from '../images/study-method/4.svg';

const NewStudyMethod = () => {
	return (
		<section className={style.mainSection}>
			<div className={style.mainContainer}>
				<div className={style.imgsContainer1}>
					<div className={style.imgsContainer2}>
						<img className={style.img1} src={study1} alt='study1' />
						{/* <img className={style.img2} src={study2} alt='study1' /> */}
						{/* <img
							className={style.imgPuntos}
							src='https://ifingerstudio.com/eduvalt/wp-content/themes/eduvalt/assets/img/others/about_dots.svg'
							alt='svg'
						/> */}

						{/* <svg
							className={style.circle}
							width='344'
							height='344'
							viewBox='0 0 344 344'
							fill='none'
							xmlns='http://www.w3.org/2000/svg'
						>
							<rect
								x='20'
								y='20'
								width='304'
								height='304'
								rx='152'
								stroke='currentcolor'
								stroke-width='40'
							></rect>
						</svg> */}

						<div className={style.box}>
							<h4>
								Más de 25.000 resultados <br /> reales de nuestros alumnos
							</h4>
						</div>

						<div className={style.box2}>
							<h4>Online</h4>
						</div>
					</div>
				</div>
				<div className={style.textContainer}>
					<div className={style.bubble}>
						<span>Método de estudio</span>
					</div>

					<h1>
						{' '}
						Formamos Especialistas 3D
						{/* <b> Especialistas 3D </b> */}
					</h1>

					<p>
						Creamos un plan de estudios en Blender para que domines escultura, preparación e
						impresión 3D con un flujo profesional, logrando resultados profesionales en corto tiempo
						y con certificación universitaria.
					</p>

					<div className={style.cardsMainContainer}>
						<div className={style.cardContainer}>
							{/* <FaUsers style={{ color: '#2494e4' }} /> */}
							<img src={img1} alt='1' style={{ maxWidth: '40px' }} />
							<h2>
								<b>5 meses</b>
								<br /> Online en vivo
							</h2>
						</div>

						<div className={style.cardContainer}>
							{/* <IoDocumentText style={{ color: '#219653' }} /> */}
							<img src={img2} alt='2' style={{ maxWidth: '40px' }} />
							<h2>
								<b>Material</b>
								<br /> de ayuda
							</h2>
						</div>

						<div className={style.cardContainer}>
							{/* <FaUserGraduate style={{ color: '#9B51E0' }} /> */}
							<img src={img3} alt='3' style={{ maxWidth: '40px' }} />
							<h2>
								<b>Certificación</b>
								<br /> doble
							</h2>
						</div>

						<div className={style.cardContainer}>
							{/* <BsCollectionPlayFill style={{ color: '#FF2E2E' }} /> */}
							<img src={img4} alt='4' style={{ maxWidth: '40px' }} />
							<h2>
								<b>Actualizaciones</b>
								<br /> permanentes
							</h2>
						</div>
					</div>

					<a
						className={style.button1}
						href='https://calendly.com/libel/charla-informativas-personalizadas'
					>
						Agenda una reunión virtual
					</a>
				</div>
			</div>
		</section>
	);
};

export default NewStudyMethod;
